import React from 'react'
import TableCustom from '../../../components/table/tableCustom';
import StateComponents from '../../../components/state-component/StateComponents';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import ManageState from './manageState';
import { useTranslation } from 'react-i18next';
import { debouncedApiCall } from '../../../utils/app.utils';

export default function StudentRegistrationInformation() {
    const { t, i18n } = useTranslation();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,

        setKeyword,
        set_id_degree,
        id_degree,
        degree,
        set_id_faculty,
        faculty,
        id_faculty,
        start_year,
        set_id_start_year,
        end_year,
        set_id_end_year,
        academicYearList,
        status,
        setStatus

    } = ManageState()
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("ข้อมูลทะเบียนนักศึกษา")}
                // hidden_sub_title
                // navigateContent={
                //     <NavigateListCustom
                //         navigateData={[
                //             {
                //                 key: "complaintSubmit",
                //                 name: t("ตั้งค่า"),
                //                 disabled_match: true,
                //                 pathName: ""
                //             },
                //             {
                //                 key: "complaintSubmit",
                //                 name: t("หมวดหมู่แกลเลอรี"),
                //                 pathName: routeName.cms_website.GalleryTypeManagement
                //             },
                //         ]}
                //     />
                // }

                content={
                    <div className='w-full'>

                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            sxContainer={{ marginTop: "10px" }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        placeholder: t("ค้นหาชื่อ - นามสกุล/ชื่อฉายา"),
                                        onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            set_id_degree(e.target.value)
                                        },
                                        options: [{
                                            label: t('ระดับทั้งหมด'),
                                            value: "ALL",
                                        }, ...degree?.map((item: any) => {
                                            return {
                                                label: i18n.language === "en" ? (item?.degree_name_eng || item?.degree_name) : item?.degree_name,
                                                value: item?.id_degree,
                                            }
                                        })],
                                        selectId: "",
                                        value: id_degree || '',
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            set_id_faculty(e.target.value)
                                        },
                                        options: [{
                                            label: t('หลักสูตรทั้งหมด'),
                                            value: "ALL",
                                        }, ...faculty?.map((item: any) => {
                                            return {
                                                label: i18n.language === "en" ? (item?.faculty_name_eng || item?.faculty_name) : item?.faculty_name,
                                                value: item?.id_faculty,
                                            }
                                        })],
                                        selectId: "",
                                        value: id_faculty || '',
                                    }
                                },

                                {
                                    seq: 4,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            set_id_start_year(e.target.value)
                                        },
                                        options: [{
                                            label: t('ปีทั้งหมด'),
                                            value: "ALL",
                                        }, ...academicYearList?.map((item: any) => {
                                            return {
                                                label: item?.academic_year,
                                                value: item?.academic_year,
                                            }
                                        })],
                                        selectId: "",
                                        value: start_year || '',
                                    }
                                },
                                {
                                    seq: 5,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            set_id_end_year(e.target.value)
                                        },
                                        options: [{
                                            label: t('ปีทั้งหมด'),
                                            value: "ALL",
                                        }, ...academicYearList?.map((item: any) => {
                                            return {
                                                label: item?.academic_year,
                                                value: item?.academic_year,
                                            }
                                        })],
                                        selectId: "",
                                        value: end_year || '',
                                    }
                                },
                                {
                                    seq: 6,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            setStatus(e.target.value)
                                        },
                                        options: [{
                                            label: t('สถานะทั้งหมด'),
                                            value: "ALL",
                                        },
                                        { label: t('กำลังศึกษา'), value: 'STUDYING' },
                                        { label: t('จบการศึกษา'), value: 'FINISH_STUDYING' },
                                        { label: t('พ้นสภาพ'), value: 'NO_LONGER_STUDENT' },
                                        { label: t('ลาออก'), value: 'RESIGN' },
                                        { label: t('พักการเรียน'), value: 'STUDENT_SUSPENSION' },
                                        ],
                                        selectId: "",
                                        value: status || '',
                                    }
                                },

                            ]}
                        />

                        <section className='w-full mt-4'>
                            <TableCustom
                                tableMinWidth={1440}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={data?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                    </div>
                }
            />

        </div>
    )
}
